import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PageContent from './components/Content';

const ExamplePage = () => (
  <Container className='dashboard'>
    <Row>
      <Col md={12}>
        <h3 className='page-title'>Variations</h3>
      </Col>
    </Row>
    <Row>
      <PageContent />
    </Row>
  </Container>
);

export default ExamplePage;
